// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J7ZTw","controls":"styles_controls__2WJlz","charLimit":"styles_charLimit__1AeWM","input":"styles_input__3hEY7","send":"styles_send__1WsVL"};